import { useCallback, useMemo } from 'react'

import { Button, ButtonProps } from 'antd'
import { Menu } from 'govwell-ui'

import useDisclosure from 'src/hooks/use-disclosure'
import { renderActionItemAsMenuItem } from 'src/hooks/use-make-action-item'

import Icon from '../govwell-ui/components/Icon'
import { IconKey } from '../govwell-ui/components/Icon/util'
import { ActionItem } from '../govwell-ui/types'

interface Props {
  items: ActionItem[]
  id?: string
  icon?: IconKey
  buttonType?: ButtonProps['type']
  buttonSize?: ButtonProps['size']
  onOpen?: () => void
  title?: string
}
export const EllipsisButton = (props: Props) => {
  const { items, id, icon, buttonSize, buttonType, onOpen: onOpenProp, title = 'More' } = props
  const { isOpen, open, close } = useDisclosure()

  const handleOpen = useCallback(() => {
    open()
    onOpenProp?.()
  }, [open, onOpenProp])

  const { nonDestructiveItems, destructiveItems } = useMemo(() => {
    const nonDestructive: ActionItem[] = []
    const destructive: ActionItem[] = []
    for (const item of items) {
      if (item.isDestructive) {
        destructive.push(item)
      } else {
        nonDestructive.push(item)
      }
    }
    return { nonDestructiveItems: nonDestructive, destructiveItems: destructive }
  }, [items])

  return (
    <>
      <Menu isOpen={isOpen} onClose={close} onOpen={handleOpen}>
        <Menu.Trigger>
          <Button
            id={id}
            onClick={(e) => e.stopPropagation()}
            size={buttonSize || 'small'}
            icon={<Icon icon={icon || 'FaChevronDown'} />}
            type={buttonType}
          >
            {!icon && title}
          </Button>
        </Menu.Trigger>
        <Menu.Content align="end" side="bottom">
          {nonDestructiveItems.map(renderActionItemAsMenuItem)}
          {destructiveItems.length > 0 && (
            <>
              <Menu.Separator className="my-1 h-px bg-neutral-200" />
              {destructiveItems.map(renderActionItemAsMenuItem)}
            </>
          )}
        </Menu.Content>
      </Menu>
    </>
  )
}
